import { render, staticRenderFns } from "./SaleLogBtn.vue?vue&type=template&id=61d4fff7&scoped=true&"
import script from "./SaleLogBtn.vue?vue&type=script&lang=js&"
export * from "./SaleLogBtn.vue?vue&type=script&lang=js&"
import style0 from "./SaleLogBtn.vue?vue&type=style&index=0&id=61d4fff7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d4fff7",
  null
  
)

export default component.exports